import Work8 from "../../assets/adminDashboard.png";
import basha_lagbe from "../../assets/basaLagbe.png";
import Work2 from "../../assets/evernet_internet.png";
import Work6 from "../../assets/hasbi_academi_detailsPage.png";
import Work1 from "../../assets/hotem_room_booking_app.png";
import Work3 from "../../assets/machbazaar.png";
import microfinance_img from "../../assets/microfinance.png";
import Work7 from "../../assets/peguin_fashion.png";
import Work5 from "../../assets/pixabay_image_finder.png";
import Work4 from "../../assets/vip_dokan.png";

export const projectsData = [
  {
    id: 1,
    image: microfinance_img,
    title: "Microfinance Web Application",
    url: "https://microfinance-app.vercel.app/",
    code: "https://github.com/Saad-001/microfinance-app",
    category: "FullStack",
    technology_tags: [
      "Next.Js",
      "NextAuth.js",
      "MySql",
      "Prisma",
      "Planetscale",
      "Cloudinary",
    ],
  },
  {
    id: 2,
    image: basha_lagbe,
    title: "House Buy/Sell/Rental Website",
    url: "http://wahid1099.pythonanywhere.com/",
    code: "https://github.com/Saad-001/Basa_Lagbe",
    category: "FullStack",
    technology_tags: ["Html", "Bootstrap", "Python", "Django", "MySql"],
  },
  {
    id: 3,
    image: Work8,
    title: "Complete MERN Admin Dashboard",
    url: "https://admin-dashboard-app-5m8d.onrender.com",
    code: "https://github.com/Saad-001/admin-dashboard-mern-app",
    category: "FullStack",
    technology_tags: [
      "React",
      "Material UI",
      "Node.Js",
      "Express.Js",
      "Mongoose",
      "MongoDB",
    ],
  },
  {
    id: 4,
    image: Work1,
    title: "Hotel Room Booking Website",
    url: "https://merry-cheesecake-75637f.netlify.app/",
    code: "https://github.com/Saad-001/hotel-room-booking-app-frontend",
    category: "Static",
    technology_tags: ["React"],
  },
  {
    id: 5,
    image: Work2,
    title: "Evernet Internet",
    url: "https://60fc19f23016ee00083a1285--competent-jepsen-e72263.netlify.app/",
    code: "https://github.com/Saad-001/Evernet-Internet",
    category: "Static",
    technology_tags: ["React", "Tailwind Css"],
  },
  {
    id: 6,
    image: Work3,
    title: "Machbazaar E-commerce",
    url: "https://jolly-lewin-276b3d.netlify.app/",
    code: "https://github.com/Saad-001/MachBazaar",
    category: "Static",
    technology_tags: ["Html", "Bootstrap", "Javascript"],
  },
  {
    id: 7,
    image: Work4,
    title: "VIP Dokan E-commerce",
    url: "https://stoic-villani-dbacc3.netlify.app/",
    code: "https://github.com/Saad-001/VipDokan",
    category: "Static",
    technology_tags: ["Html", "Bootstrap", "Javascript"],
  },
  {
    id: 8,
    image: Work5,
    title: "Pixabay Image Finder",
    url: "https://upbeat-shannon-7ecb87.netlify.app/",
    code: "#",
    category: "Static",
    technology_tags: ["React"],
  },
  {
    id: 9,
    image: Work6,
    title: "Hasbi Academi",
    url: "https://quizzical-goldstine-b3e706.netlify.app/",
    code: "https://github.com/Saad-001/HasbiAcademy_bootstrap",
    category: "Static",
    technology_tags: ["Html", "Bootstrap", "Javascript"],
  },

  {
    id: 10,
    image: Work7,
    title: "Penguin Fashion E-commerce",
    url: "https://saad-001.github.io/penguin-fashion-landing-page/",
    code: "https://github.com/Saad-001/penguin-fashion-landing-page",
    category: "Static",
    technology_tags: ["Html", "CSS"],
  },
];

export const portfolioNav = [
  {
    name: "All",
  },
  {
    name: "FullStack",
  },
  {
    name: "Static",
  },
];
